module.exports = __webpack_public_path__ + "57175c9ba2e59026a22e3fcce785836e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/alatke.png
// module id = 468
// module chunks = 0